module.exports = __webpack_public_path__ + "assets/img/siding-1.3efd099c.jpg";